import { createSlice } from "@reduxjs/toolkit";

const DocumentSlice = createSlice({
    name: "Documents",
    initialState:{
        items:[]
    },
    reducers:{
        addDocuments:(state, action)=>{
            state.items.push(action.payload)
        }
    }
})

export const {addTags} = DocumentSlice.actions;

export default DocumentSlice.reducer;